import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Helper function to toggle bookmarks visibility
const toggleBookmarksVisibility = function () {
  const bookmarksEl = document.querySelector('.bookmarks');
  if (!bookmarksEl) return;

  // Show bookmarks only if user has bookmarks
  if (model.state.bookmarks && model.state.bookmarks.length > 0) {
    bookmarksEl.classList.remove('hidden');
  } else {
    bookmarksEl.classList.add('hidden');
  }
};

const controlRecipes = async function () {
  try {
    const id = window.location.hash.slice(1);
    if (!id) {
      // No hash = close modal
      recipeView.close();
      return;
    }
    
    recipeView.renderSpinner();
    recipeView.open(); // Open modal

    // Show bookmarks sidebar when viewing recipe (if user has bookmarks)
    toggleBookmarksVisibility();

    // 0) Update results view to mark selected search result (only if search results exist)
    if (model.state.search.results && model.state.search.results.length > 0) {
      resultsView.update(model.getSearchResultsPage());
    }

    // 1) Loading recipe
    await model.loadRecipe(id);

    // 2) Rendering recipe
    recipeView.render(model.state.recipe);
  } catch (err) {
    recipeView.renderError();
    console.error(err);
  }
};

const controlSearchResults = async function () {
  try {
    // 1) Show loading spinner
    resultsView.renderSpinner();

    // 2) Hide bookmarks sidebar when searching
    const bookmarksEl = document.querySelector('.bookmarks');
    if (bookmarksEl) bookmarksEl.classList.add('hidden');

    // 3) Get search query
    const query = searchView.getQuery();
    
    // 4) Validate empty search
    if (!query || query.trim() === '') {
      resultsView.renderError(
        'Please enter a search term. Try: pizza, pasta, avocado, chicken...'
      );
      return;
    }

    // 5) Load search results from API
    await model.loadSearchResults(query);

    // 6) Check if results are empty
    const results = model.getSearchResultsPage();
    if (!results.results || results.results.length === 0) {
      resultsView.renderError(
        `No recipes found for "${query}". Please try a different search term.`
      );
      return;
    }

    // 7) Render results
    resultsView.render(results);
  } catch (err) {
    console.error(err);
    // Check if it's a network/API error or invalid product
    if (err.message && err.message.includes('Failed to fetch')) {
      resultsView.renderError(
        'Unable to connect to the server. Please check your internet connection.'
      );
    } else {
      resultsView.renderError(
        `No recipes found for your search. Please try a different term.`
      );
    }
  }
};

const controlPagination = function (goToPage) {
  // 1) Render NEW results
  resultsView.render(model.getSearchResultsPage(goToPage));
};

const controlServings = function (newServings) {
  // Update the recipe servings (in state)
  model.updateServings(newServings);

  // Update the recipe view
  recipeView.update(model.state.recipe);
};

const controlAddBookmark = function () {
  // 1) Add/remove bookmark
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  // 2) Update recipe view
  recipeView.update(model.state.recipe);

  // 3) Render bookmarks
  bookmarksView.render(model.state.bookmarks);

  // 4) Toggle bookmarks visibility based on whether user has bookmarks
  toggleBookmarksVisibility();
};

const controlBookmarks = function () {
  bookmarksView.render(model.state.bookmarks);
  // Toggle visibility based on whether user has bookmarks
  toggleBookmarksVisibility();
};

const controlShowRecipe = function (id) {
  window.location.hash = `#${id}`;
};

const controlRemoveBookmark = function (id) {
  model.deleteBookmark(id);
  bookmarksView.render(model.state.bookmarks);
  toggleBookmarksVisibility();
  
  // If the removed bookmark was the currently displayed recipe, close the modal
  if (model.state.recipe.id === id) {
    recipeView.close();
    window.location.hash = '';
  }
};

const controlAddRecipe = async function (newRecipe) {
  try {
    // Show loading spinner
    addRecipeView.renderSpinner();

    // Upload the new recipe data
    await model.uploadRecipe(newRecipe);

    // Render recipe
    recipeView.render(model.state.recipe);

    // Success message
    addRecipeView.renderMessage();

    // Render bookmark view
    bookmarksView.render(model.state.bookmarks);

    // Show bookmarks since recipe was auto-bookmarked
    toggleBookmarksVisibility();

    // Change ID in URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    // Close form window
    setTimeout(function () {
      addRecipeView.toggleWindow();
    }, 2500);
  } catch (err) {
    console.error('💥', err);
    addRecipeView.renderError(err.message);
  }
};

const init = function () {
  bookmarksView.addHandlerRender(controlBookmarks);
  bookmarksView.addHandlerShowRecipe(controlShowRecipe);
  bookmarksView.addHandlerRemoveBookmark(controlRemoveBookmark);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  resultsView.addHandlerClick(controlRecipes);
  resultsView.addHandlerPagination(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
  
  // Hide bookmarks on initial load if user has no bookmarks
  toggleBookmarksVisibility();
};
init();

